import LoadingState from '@/api/LoadingState';

const state = {
  runInformation: {},
  runDocuments: [],
  timetable: [],
  exercises: [],
  candidate: {},
  currentExerciseId: null,
  loadingState: {
    runInfo: LoadingState.INITIAL,
    runDocuments: LoadingState.INITIAL,
    timetable: LoadingState.INITIAL
  }
}

export default state
